import { useContext } from "react";
import { useQuery } from "react-query";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

// IA (Márcia) configurada na empresa: integração n8n com URL vinculada a uma
// conexão ou fila. Sem ela, o card mostra Offline e somem o botão
// "Atendimento AI" e a seção "IA atendendo".
const useAiStatus = () => {
  const { user } = useContext(AuthContext);
  const companyId = user?.companyId;

  const query = useQuery(
    ["aiStatus", companyId],
    async () => {
      const { data } = await api.get("/queueIntegration/ai-status");
      return Boolean(data?.configured);
    },
    { enabled: !!companyId, staleTime: 60000, refetchInterval: 60000 }
  );

  return { aiConfigured: query.data === true, isLoading: query.isLoading };
};

export default useAiStatus;
